import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'corner-down-right', 'CornerDownRight', [["path",{"d":"M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"}]]);